"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flex = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = require("../Box");
exports.Flex = react_1.forwardRef((_a, ref) => {
    var { align, justify, wrap, direction } = _a, props = __rest(_a, ["align", "justify", "wrap", "direction"]);
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ ref: ref, display: "flex", flexDirection: direction, alignItems: align, justifyContent: justify, flexWrap: wrap }, props), void 0));
});
//# sourceMappingURL=index.js.map